module.exports = __webpack_public_path__ + "static/media/Taskrabbit-Paintbrush.c4242b5a.svg";